'use strict';

const Vue = require('vue');
const Modal = require('./modal/modal.vue');

const modalAppEl = '#app-modal';
const modalVueEl = '#modal';

let modalObject; /* eslint-disable-line */

const initEventBus = () => {
    // Setup eventbus to allow modal to pass back data
    window.eventBus = window.eventBus || new Vue();

    window.eventBus.$on('shouldOpenModal', (data) => {
        prepareMarkup();
        createModal(data);
    });

    window.eventBus.$on('modalClosed', (data) => {
        destroyModal(data.modalCustomId);
    });
};

/**
 * Prepares the markup for the modal to be attached to
 */
const prepareMarkup = () => {
    const template = `
        <div id="app-modal">
        </div>
    `;

    $('body').append(template);
};

/**
 * Creates the Modal App
 */
const createModal = (data) => {
    modalObject = new Vue({
        el: modalAppEl,
        store: data.store,
        components: {
            Modal
        },
        computed: {
            config() {
                return data;
            }
        },
        data() {
            return {
                shouldShowModal: true
            };
        },
        template: `<modal :config = "config"></modal>`,
    });
};

/**
 * Removes the Modal App from the DOM
 */
const destroyModal = () => {
    $(modalVueEl).remove();
};

const modalApp = {
    init: () => {
        initEventBus();
    }
};

module.exports = modalApp;
